module.exports = {
  result:
    'This coupon gives you a reduction of %(discountPercent)s%% on pecheur.com. It is valid until %(until)s. You need to enter it at the last step of your order on ',
}
